import { render, staticRenderFns } from "./user-preference.vue?vue&type=template&id=7f3e33a8&scoped=true&lang=pug&"
import script from "./user-preference.vue?vue&type=script&lang=js&"
export * from "./user-preference.vue?vue&type=script&lang=js&"
import style0 from "./user-preference.vue?vue&type=style&index=0&id=7f3e33a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3e33a8",
  null
  
)

component.options.__file = "user-preference.vue"
export default component.exports